import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How does the AI lead scoring work?",
    answer:
      "Our AI analyzes multiple data points including engagement history, company attributes, and behavioral signals to predict conversion probability. The model learns from your team's wins and losses to continuously improve accuracy.",
  },
  {
    question: "Can I integrate with my existing CRM?",
    answer:
      "Yes! Aiveliq360 integrates with popular CRMs like Salesforce, HubSpot, and Pipedrive. We also offer API access for custom integrations on Enterprise plans.",
  },
  {
    question: "What channels does the outreach sequencer support?",
    answer:
      "Our multi-channel sequencer supports Email, SMS, WhatsApp, and LinkedIn. You can create automated sequences that combine multiple channels with AI-personalized messaging.",
  },
  {
    question: "How does real-time call assist work?",
    answer:
      "During calls, our AI transcribes the conversation in real-time, detects customer objections, and provides suggested responses. It also tracks sentiment and key topics discussed.",
  },
  {
    question: "Is my data secure?",
    answer:
      "Absolutely. We use enterprise-grade encryption, strict access controls, and are SOC 2 compliant. Your data is isolated per tenant and never shared or used to train models for other customers.",
  },
  {
    question: "What's included in the free trial?",
    answer:
      "The 14-day free trial includes full access to all features in your selected plan. No credit card required to start. You can upgrade, downgrade, or cancel anytime.",
  },
  {
    question: "Do you offer training and onboarding?",
    answer:
      "Yes! All plans include access to our knowledge base and video tutorials. Growth and Enterprise plans include dedicated onboarding sessions and priority support.",
  },
  {
    question: "Can I export my data if I cancel?",
    answer:
      "Yes, you can export all your data at any time in CSV or JSON format. We believe in data portability and make it easy to take your data with you.",
  },
];

export function FAQ() {
  return (
    <section className="py-12 bg-muted/30">
      <div className="max-w-2xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold mb-2">
            Frequently Asked <span className="gradient-text">Questions</span>
          </h2>
          <p className="text-muted-foreground">
            Everything you need to know about Aiveliq360
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="glass rounded-lg px-4 border-border/50"
            >
              <AccordionTrigger className="text-left text-sm font-medium hover:no-underline py-3">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm pb-3">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
